import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{staticClass:"ml-2",attrs:{"color":"primary"},on:{"click":function($event){_vm.dialog = true}}},[_vm._v("\n    Novo\n  ")]),_c('SysDialog',{attrs:{"titulo":"Novo menu de parametrização"},on:{"click:primary":function($event){return _vm.salvarMenu()}},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('Form',{attrs:{"item":_vm.item,"dialog":_vm.dialog}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }